// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-points__entry small{text-transform:lowercase}.account-points__info{display:flex;justify-content:space-between;align-items:center}.account-points__entry-title{display:flex;width:100%;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
